var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1916 24.5002C48.1916 37.8673 37.4271 48.7035 24.1485 48.7035C10.8699 48.7035 0.105469 37.8673 0.105469 24.5002C0.105469 11.1331 10.8699 0.296875 24.1485 0.296875C37.4271 0.296875 48.1916 11.1331 48.1916 24.5002Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5763 37.6919H32.7218C33.5109 37.6919 34.1506 37.0522 34.1506 36.2631V13.4025C34.1506 12.6134 33.5109 11.9737 32.7218 11.9737H15.5763C14.7872 11.9737 14.1475 12.6134 14.1475 13.4025V36.2631C14.1475 37.0522 14.7872 37.6919 15.5763 37.6919ZM32.7218 39.1207H15.5763C13.9981 39.1207 12.7188 37.8413 12.7188 36.2631V13.4025C12.7188 11.8243 13.9981 10.5449 15.5763 10.5449H32.7218C34.2999 10.5449 35.5794 11.8243 35.5794 13.4025V36.2631C35.5794 37.8413 34.2999 39.1207 32.7218 39.1207Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8711 17.7534L16.6027 18.4849L18.236 16.8516",
    stroke: "white",
    strokeWidth: 1.18244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.8125,
    y: 16.9121,
    width: 13.401,
    height: 1.51353,
    rx: 0.756765,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8711 24.1166L16.6027 24.8482L18.236 23.2148",
    stroke: "white",
    strokeWidth: 1.18244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8125,
    y: 23.2754,
    width: 13.401,
    height: 1.51353,
    rx: 0.756765,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2656 30.4799L16.9972 31.2114L18.6305 29.5781",
    stroke: "white",
    strokeWidth: 1.18244,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.207,
    y: 29.6387,
    width: 12.6127,
    height: 1.51353,
    rx: 0.756765,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentName);
export default __webpack_public_path__ + "static/media/assessment-name.f3c9fb289de9bf525e512490a36d1c87.svg";
export { ForwardRef as ReactComponent };